(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-qk-upsell-root]";
  var INPUT_SELECTOR = "input[data-qk-upsell-item]";
  var CARD_SELECTOR = "[data-qk-upsell-card]";
  var CARD_TRIGGER_SELECTOR = "[data-qk-upsell-trigger]";
  var TOGGLE_SELECTOR = "[data-qk-upsell-toggle]";
  var PREVIEW_TRIGGER_SELECTOR = "[data-qk-upsell-preview-trigger]";
  var PREVIEW_DIALOG_SELECTOR = "[data-qk-upsell-preview]";
  var PREVIEW_CLOSE_SELECTOR = "[data-qk-upsell-preview-close]";
  var CAROUSEL_LIST_SELECTOR = "[data-qk-upsell-list]";
  var CAROUSEL_CONTROLS_SELECTOR = "[data-qk-upsell-carousel-controls]";
  var CAROUSEL_DOTS_SELECTOR = "[data-qk-upsell-carousel-dots]";
  var CAROUSEL_PREV_SELECTOR = "[data-qk-upsell-carousel-prev]";
  var CAROUSEL_NEXT_SELECTOR = "[data-qk-upsell-carousel-next]";
  var MAIN_ATC_PRICE_ROOT_SELECTOR = "[data-qk-main-atc-price-root]";
  var MAIN_ATC_PRICE_SELECTOR = "[data-qk-main-atc-price]";
  var MAIN_ATC_PRICE_INIT_ATTR = "data-qk-main-atc-price-initialized";
  var INIT_ATTR = "data-qk-upsell-initialized";

  function parseInteger(value, fallback) {
    var parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function toTruthy(value) {
    var normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on";
  }

  function cssEscape(value) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
      return CSS.escape(String(value));
    }

    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function formatMoney(cents, format) {
    var formatString = String(format || window.themeVariables?.settings?.moneyFormat || "${{amount}}");
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return "0";
      }

      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split(".");
      var amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var decimals = parts[1] ? decimal + parts[1] : "";

      return amount + decimals;
    }

    var match = formatString.match(placeholderRegex);
    var token = match && match[1] ? match[1] : "amount";
    var value;

    switch (token) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function prefersReducedMotion() {
    return typeof window.matchMedia === "function"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function animateTotalValue(element, targetCents, moneyFormat, pricePrefix) {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    var currentCents = Math.max(
      0,
      parseInteger(element.getAttribute("data-qk-upsell-current-cents"), targetCents),
    );

    if (element.qkUpsellTotalFrame) {
      cancelAnimationFrame(element.qkUpsellTotalFrame);
      element.qkUpsellTotalFrame = 0;
    }

    element.classList.remove("is-increasing", "is-decreasing");
    element.setAttribute("data-qk-upsell-target-cents", String(targetCents));

    var renderValue = function (value) {
      var roundedValue = Math.max(0, Math.round(value));
      element.setAttribute("data-qk-upsell-current-cents", String(roundedValue));
      element.textContent = pricePrefix + formatMoney(roundedValue, moneyFormat);
    };

    if (currentCents === targetCents || prefersReducedMotion()) {
      renderValue(targetCents);
      return;
    }

    var directionClass = targetCents > currentCents ? "is-increasing" : "is-decreasing";
    void element.offsetWidth;
    element.classList.add(directionClass);

    var duration = 280;
    var startTime = null;

    var step = function (timestamp) {
      if (startTime == null) {
        startTime = timestamp;
      }

      var progress = Math.min(1, (timestamp - startTime) / duration);
      var easedProgress = 1 - Math.pow(1 - progress, 3);
      renderValue(currentCents + (targetCents - currentCents) * easedProgress);

      if (progress < 1) {
        element.qkUpsellTotalFrame = requestAnimationFrame(step);
      } else {
        element.qkUpsellTotalFrame = 0;
        element.classList.remove(directionClass);
      }
    };

    element.qkUpsellTotalFrame = requestAnimationFrame(step);
  }

  function resolveAssociatedControl(form, predicate) {
    if (!(form instanceof HTMLFormElement) || typeof predicate !== "function") {
      return null;
    }

    var directControls = Array.from(form.elements || []);
    for (var i = 0; i < directControls.length; i += 1) {
      if (predicate(directControls[i])) {
        return directControls[i];
      }
    }

    var formId = String(form.id || "").trim();
    if (!formId) {
      return null;
    }

    var escapedId = cssEscape(formId);
    var associated = document.querySelectorAll("[form=\"" + escapedId + "\"]");
    for (var j = 0; j < associated.length; j += 1) {
      if (predicate(associated[j])) {
        return associated[j];
      }
    }

    return null;
  }

  function resolveQuantityInput(form) {
    return resolveAssociatedControl(form, function (control) {
      return (
        control instanceof HTMLInputElement &&
        control.name === "quantity" &&
        control.type !== "hidden" &&
        !control.disabled
      );
    });
  }

  function resolveParentQuantity(quantityInput) {
    if (!(quantityInput instanceof HTMLInputElement)) {
      return 1;
    }

    var fallbackValue = parseInteger(quantityInput.defaultValue, 1);
    var value = parseInteger(quantityInput.value, fallbackValue);
    return Math.max(1, value);
  }

  function resolveVariantUnitPrice(form) {
    var priceInput = resolveAssociatedControl(form, function (control) {
      return control instanceof HTMLInputElement && control.hasAttribute("data-qk-variant-price");
    });

    return priceInput instanceof HTMLInputElement
      ? Math.max(0, parseInteger(priceInput.value, 0))
      : 0;
  }

  function resolveUpsellTotalForForm(formId) {
    return Array.from(document.querySelectorAll(ROOT_SELECTOR)).reduce(function (total, upsellRoot) {
      if (!(upsellRoot instanceof HTMLElement) || upsellRoot.getAttribute("data-form-id") !== formId) {
        return total;
      }

      return total + Math.max(0, parseInteger(upsellRoot.getAttribute("data-qk-upsell-total-cents"), 0));
    }, 0);
  }

  function resolveLubricationCheckbox(formId) {
    var lubricationNode = Array.from(document.querySelectorAll("[data-qk-lube-pdp][data-form-id]")).find(function (node) {
      return node instanceof HTMLElement && node.getAttribute("data-form-id") === formId;
    });

    if (!(lubricationNode instanceof HTMLElement)) {
      return null;
    }

    var checkbox = lubricationNode.querySelector("[data-qk-lube-checkbox]");
    return checkbox instanceof HTMLInputElement ? checkbox : null;
  }

  function resolveFloatingAtcPrice(formId) {
    var quickAdd = Array.from(document.querySelectorAll("product-quick-add[form]")).find(function (node) {
      return node instanceof HTMLElement && node.getAttribute("form") === formId;
    });

    if (!(quickAdd instanceof HTMLElement)) {
      return null;
    }

    return quickAdd.querySelector(".qk-product-quick-add-mobile__price");
  }

  function setMoneyElementText(element, text) {
    if (!(element instanceof Element)) {
      return;
    }

    var translatedMoney = element.matches(".transcy-money")
      ? element
      : element.querySelector(".transcy-money");
    if (translatedMoney instanceof Element) {
      translatedMoney.textContent = text;
      return;
    }

    var liveValue = element.querySelector("[data-qk-live-price-value]");
    if (liveValue instanceof Element) {
      liveValue.textContent = text;
      return;
    }

    element.textContent = text;
  }

  function initMainAtcPriceRoot(root) {
    if (!(root instanceof HTMLElement) || root.getAttribute(MAIN_ATC_PRICE_INIT_ATTR) === "1") {
      return;
    }

    var formId = String(root.getAttribute("form") || "").trim();
    var form = formId ? document.getElementById(formId) : null;
    var initialPriceElement = root.querySelector(MAIN_ATC_PRICE_SELECTOR);
    if (!(form instanceof HTMLFormElement) || !(initialPriceElement instanceof HTMLElement)) {
      return;
    }

    root.setAttribute(MAIN_ATC_PRICE_INIT_ATTR, "1");

    var actionLabelElement = root.querySelector(".qk-main-atc-label");
    var availableActionLabel = actionLabelElement instanceof HTMLElement
      ? String(actionLabelElement.textContent || "").trim()
      : String(window.themeVariables?.strings?.addToCartButton || "Add to cart");
    var activeVariantAvailable = true;

    var ensureMainAtcPriceElement = function () {
      var currentPriceElement = root.querySelector(MAIN_ATC_PRICE_SELECTOR);
      if (currentPriceElement instanceof HTMLElement) {
        return currentPriceElement;
      }

      if (!activeVariantAvailable) {
        return null;
      }

      var button = root.querySelector('button[type="submit"]');
      if (!(button instanceof HTMLButtonElement)) {
        return null;
      }

      var buttonContent = button.getAttribute("is") === "custom-button"
        ? button.firstElementChild
        : button;
      if (!(buttonContent instanceof HTMLElement)) {
        return null;
      }

      var content = document.createElement("span");
      content.className = "qk-main-atc-content";

      var price = document.createElement("span");
      price.className = "qk-main-atc-price";
      price.setAttribute("data-qk-main-atc-price", "");

      var separator = document.createElement("span");
      separator.className = "qk-main-atc-separator";
      separator.setAttribute("aria-hidden", "true");
      separator.textContent = "-";

      var label = document.createElement("span");
      label.className = "qk-main-atc-label";
      label.textContent = availableActionLabel;

      content.append(price, separator, label);
      buttonContent.replaceChildren(content);
      return price;
    };

    var moneyFormat = String(root.getAttribute("data-qk-money-format") || "");
    if (moneyFormat.indexOf("<") !== -1) {
      moneyFormat = moneyFormat.replace(/<[^>]*>/g, "").trim();
    }

    var update = function () {
      var quantity = resolveParentQuantity(resolveQuantityInput(form));
      var baseTotalCents = resolveVariantUnitPrice(form) * quantity;
      var upsellTotalCents = resolveUpsellTotalForForm(formId);
      var lubricationUnitPriceCents = Math.max(
        0,
        parseInteger(form.getAttribute("data-qk-lube-unit-price-cents"), 0),
      );
      var lubricationCheckbox = resolveLubricationCheckbox(formId);
      var lubricationTotalCents = lubricationCheckbox instanceof HTMLInputElement
        && lubricationCheckbox.checked
        && !lubricationCheckbox.disabled
        ? lubricationUnitPriceCents * quantity
        : 0;
      var purchaseTotalCents = Math.max(
        0,
        baseTotalCents + upsellTotalCents + lubricationTotalCents,
      );
      var formattedTotal = formatMoney(purchaseTotalCents, moneyFormat);
      var priceElement = ensureMainAtcPriceElement();

      if (priceElement instanceof HTMLElement) {
        priceElement.textContent = formattedTotal;
        priceElement.setAttribute("data-qk-main-atc-current-cents", String(purchaseTotalCents));
      }
      root.setAttribute("data-qk-main-atc-total-cents", String(purchaseTotalCents));

      var floatingPrice = resolveFloatingAtcPrice(formId);
      if (floatingPrice instanceof Element) {
        setMoneyElementText(floatingPrice, formattedTotal);
      }
    };

    var productInfo = root.closest(".product-info") || document;
    var scheduleUpdate = function () {
      update();
      if (typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(update);
      }
    };

    productInfo.addEventListener("input", function (event) {
      var target = event && event.target instanceof Element ? event.target : null;
      if (target && target.matches(".quantity-selector__input")) {
        scheduleUpdate();
      }
    });

    productInfo.addEventListener("change", function (event) {
      var target = event && event.target instanceof Element ? event.target : null;
      if (target && target.matches(".quantity-selector__input, [data-qk-upsell-item], [data-qk-lube-checkbox]")) {
        scheduleUpdate();
      }
    });

    productInfo.addEventListener("click", function (event) {
      var target = event && event.target instanceof Element ? event.target : null;
      if (target && target.closest(".quantity-selector__button")) {
        scheduleUpdate();
      }
    });

    productInfo.addEventListener("qk:upsell-total:change", function (event) {
      var detail = event && event.detail && typeof event.detail === "object" ? event.detail : {};
      if (!detail.formId || detail.formId === formId) {
        update();
      }
    });

    form.addEventListener("qk:lubrication-price:change", update);
    form.addEventListener("variant:change", function (event) {
      activeVariantAvailable = Boolean(event?.detail?.variant?.available);
      scheduleUpdate();
    });
    update();
  }

  function unique(values) {
    var seen = new Set();
    return values.filter(function (value) {
      var normalized = String(value == null ? "" : value).trim();
      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);
      return true;
    });
  }

  function clampDiscountPercent(value) {
    var parsed = parseInteger(value, 0);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return 0;
    }

    return Math.max(0, Math.min(100, parsed));
  }

  function resolveResponsiveValue(root, mobileAttr, desktopAttr, mobileFallback, desktopFallback) {
    var isDesktop = typeof window.matchMedia === "function"
      ? window.matchMedia("(min-width: 1000px)").matches
      : window.innerWidth >= 1000;
    var attr = isDesktop ? desktopAttr : mobileAttr;
    var fallback = isDesktop ? desktopFallback : mobileFallback;
    return Math.max(1, parseInteger(root.getAttribute(attr), fallback));
  }

  function syncCardPressedState(root) {
    var inputs = Array.from(root.querySelectorAll(INPUT_SELECTOR));
    inputs.forEach(function (input) {
      if (!(input instanceof HTMLInputElement)) {
        return;
      }

      var trigger = input.nextElementSibling;
      if (!(trigger instanceof HTMLElement) || !trigger.matches(CARD_TRIGGER_SELECTOR)) {
        return;
      }

      trigger.setAttribute("aria-pressed", input.checked ? "true" : "false");
    });
  }

  function createCollapseController(root) {
    var cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    var actions = root.querySelector("[data-qk-upsell-actions]");
    var toggle = root.querySelector(TOGGLE_SELECTOR);
    var viewMoreLabel = String(root.getAttribute("data-qk-upsell-view-more-label") || "Vezi mai mult").trim();
    var viewLessLabel = String(root.getAttribute("data-qk-upsell-view-less-label") || "Vezi mai putin").trim();
    var expanded = false;
    var resizeTick = 0;

    if (!cards.length) {
      return {
        update: function () {}
      };
    }

    if (root.getAttribute("data-qk-upsell-layout") === "carousel") {
      cards.forEach(function (card) {
        if (card instanceof HTMLElement) {
          card.hidden = false;
        }
      });

      if (actions instanceof HTMLElement) {
        actions.hidden = true;
      }

      return {
        update: function () {}
      };
    }

    if (!viewMoreLabel) {
      viewMoreLabel = "Vezi mai mult";
    }

    if (!viewLessLabel) {
      viewLessLabel = "Vezi mai putin";
    }

    var update = function () {
      var columns = resolveResponsiveValue(
        root,
        "data-qk-upsell-columns-mobile",
        "data-qk-upsell-columns-desktop",
        3,
        6
      );
      var maxRows = resolveResponsiveValue(
        root,
        "data-qk-upsell-max-rows-mobile",
        "data-qk-upsell-max-rows-desktop",
        2,
        2
      );
      var maxVisibleItems = Math.max(1, columns * maxRows);
      var hasOverflow = cards.length > maxVisibleItems;

      if (!hasOverflow) {
        expanded = false;
      }

      cards.forEach(function (card, index) {
        if (!(card instanceof HTMLElement)) {
          return;
        }

        card.hidden = hasOverflow && !expanded ? index >= maxVisibleItems : false;
      });

      if (actions instanceof HTMLElement) {
        actions.hidden = !hasOverflow;
      }

      if (toggle instanceof HTMLElement) {
        toggle.setAttribute("aria-expanded", hasOverflow && expanded ? "true" : "false");
        toggle.textContent = hasOverflow && expanded ? viewLessLabel : viewMoreLabel;
      }
    };

    if (toggle instanceof HTMLButtonElement) {
      toggle.addEventListener("click", function () {
        expanded = !expanded;
        update();
      });
    }

    window.addEventListener(
      "resize",
      function () {
        if (resizeTick) {
          cancelAnimationFrame(resizeTick);
        }

        resizeTick = requestAnimationFrame(function () {
          resizeTick = 0;
          update();
        });
      },
      { passive: true }
    );

    return { update: update };
  }

  function createCarouselController(root) {
    if (!(root instanceof HTMLElement) || root.getAttribute("data-qk-upsell-layout") !== "carousel") {
      return {
        update: function () {}
      };
    }

    var list = root.querySelector(CAROUSEL_LIST_SELECTOR);
    var controls = root.querySelector(CAROUSEL_CONTROLS_SELECTOR);
    var dots = root.querySelector(CAROUSEL_DOTS_SELECTOR);
    var previousButton = root.querySelector(CAROUSEL_PREV_SELECTOR);
    var nextButton = root.querySelector(CAROUSEL_NEXT_SELECTOR);
    var scrollTick = 0;
    var resizeTick = 0;
    var snapPositions = [];
    var dotsSignature = "";

    if (!(list instanceof HTMLElement)) {
      return {
        update: function () {}
      };
    }

    var prefersReducedMotion = function () {
      return typeof window.matchMedia === "function"
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    };

    var calculateSnapPositions = function (maxScroll) {
      if (maxScroll <= 2) {
        return [0];
      }

      var listRect = list.getBoundingClientRect();
      var positions = Array.from(list.querySelectorAll(CARD_SELECTOR)).map(function (card) {
        if (!(card instanceof HTMLElement)) {
          return 0;
        }

        var cardRect = card.getBoundingClientRect();
        return Math.max(0, Math.min(maxScroll, cardRect.left - listRect.left + list.scrollLeft));
      });

      positions.push(0, maxScroll);
      positions.sort(function (left, right) {
        return left - right;
      });

      return positions.reduce(function (uniquePositions, position) {
        var previousPosition = uniquePositions[uniquePositions.length - 1];
        if (previousPosition == null || Math.abs(previousPosition - position) > 2) {
          uniquePositions.push(position);
        }
        return uniquePositions;
      }, []);
    };

    var rebuildDots = function (positions) {
      if (!(dots instanceof HTMLElement)) {
        return;
      }

      var nextSignature = positions.map(function (position) {
        return String(Math.round(position));
      }).join(",");

      if (nextSignature === dotsSignature) {
        return;
      }

      dotsSignature = nextSignature;
      dots.replaceChildren();

      positions.forEach(function (position, index) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "qk-upsell-grid__carousel-dot";
        dot.setAttribute("aria-label", "Mergi la poziția " + (index + 1));
        dot.addEventListener("click", function () {
          list.scrollTo({
            left: position,
            behavior: prefersReducedMotion() ? "auto" : "smooth"
          });
        });
        dots.appendChild(dot);
      });
    };

    var updateActiveDot = function (currentScroll) {
      if (!(dots instanceof HTMLElement) || snapPositions.length === 0) {
        return;
      }

      var activeIndex = snapPositions.reduce(function (nearestIndex, position, index) {
        return Math.abs(position - currentScroll) < Math.abs(snapPositions[nearestIndex] - currentScroll)
          ? index
          : nearestIndex;
      }, 0);

      Array.from(dots.querySelectorAll(".qk-upsell-grid__carousel-dot")).forEach(function (dot, index) {
        if (!(dot instanceof HTMLButtonElement)) {
          return;
        }

        if (index === activeIndex) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    var update = function () {
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var currentScroll = Math.max(0, list.scrollLeft);
      var hasOverflow = maxScroll > 2;

      snapPositions = calculateSnapPositions(maxScroll);
      rebuildDots(snapPositions);

      if (controls instanceof HTMLElement) {
        controls.hidden = !hasOverflow;
      }

      if (dots instanceof HTMLElement) {
        dots.hidden = !hasOverflow;
      }

      if (previousButton instanceof HTMLButtonElement) {
        previousButton.disabled = !hasOverflow || currentScroll <= 2;
      }

      if (nextButton instanceof HTMLButtonElement) {
        nextButton.disabled = !hasOverflow || currentScroll >= maxScroll - 2;
      }

      updateActiveDot(currentScroll);
    };

    var scrollOneCard = function (direction) {
      var firstCard = list.querySelector(CARD_SELECTOR);
      if (!(firstCard instanceof HTMLElement)) {
        return;
      }

      var computedStyle = window.getComputedStyle(list);
      var gap = Number.parseFloat(computedStyle.columnGap || computedStyle.gap || "0") || 0;
      var distance = firstCard.getBoundingClientRect().width + gap;
      list.scrollBy({
        left: direction * distance,
        behavior: prefersReducedMotion() ? "auto" : "smooth"
      });
    };

    if (previousButton instanceof HTMLButtonElement) {
      previousButton.addEventListener("click", function () {
        scrollOneCard(-1);
      });
    }

    if (nextButton instanceof HTMLButtonElement) {
      nextButton.addEventListener("click", function () {
        scrollOneCard(1);
      });
    }

    list.addEventListener(
      "scroll",
      function () {
        if (scrollTick) {
          return;
        }

        scrollTick = requestAnimationFrame(function () {
          scrollTick = 0;
          update();
        });
      },
      { passive: true }
    );

    window.addEventListener(
      "resize",
      function () {
        if (resizeTick) {
          cancelAnimationFrame(resizeTick);
        }

        resizeTick = requestAnimationFrame(function () {
          resizeTick = 0;
          update();
        });
      },
      { passive: true }
    );

    return { update: update };
  }

  function closePreview(dialog) {
    if (!(dialog instanceof HTMLElement)) {
      return;
    }

    if (typeof dialog.close === "function" && (dialog.open || dialog.hasAttribute("open"))) {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
  }

  function openPreview(root, trigger) {
    if (!(root instanceof HTMLElement) || !(trigger instanceof HTMLElement)) {
      return;
    }

    var dialog = root.querySelector(PREVIEW_DIALOG_SELECTOR);
    if (!(dialog instanceof HTMLElement)) {
      return;
    }

    var image = dialog.querySelector("[data-qk-upsell-preview-image]");
    var title = dialog.querySelector("[data-qk-upsell-preview-title]");
    var source = String(trigger.getAttribute("data-qk-upsell-preview-src") || "").trim();
    var productTitle = String(trigger.getAttribute("data-qk-upsell-preview-title") || "").trim();

    if (!source || !(image instanceof HTMLImageElement)) {
      return;
    }

    image.src = source;
    image.alt = productTitle;
    if (title instanceof HTMLElement) {
      title.textContent = productTitle;
    }

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) {
        dialog.showModal();
      }
    } else {
      dialog.setAttribute("open", "");
    }
  }

  function initUpsellRoot(root) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    if (root.getAttribute(INIT_ATTR) === "1") {
      return;
    }

    var formId = String(root.getAttribute("data-form-id") || "").trim();
    if (!formId) {
      return;
    }

    var form = document.getElementById(formId);
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    root.setAttribute(INIT_ATTR, "1");

    var matchParentQuantity = toTruthy(root.getAttribute("data-match-parent-quantity"));
    var autoDiscountEnabled = toTruthy(root.getAttribute("data-qk-upsell-auto-discount-enabled"));
    var autoDiscountPercent = autoDiscountEnabled
      ? clampDiscountPercent(root.getAttribute("data-qk-upsell-auto-discount-percent"))
      : 0;
    var moneyFormat = String(root.getAttribute("data-money-format") || "");
    var pricePrefixValue = String(root.getAttribute("data-qk-upsell-price-prefix") || "").trim();
    var pricePrefix = pricePrefixValue ? pricePrefixValue + " " : "";
    if (moneyFormat.indexOf("<") !== -1) {
      moneyFormat = moneyFormat.replace(/<[^>]*>/g, "").trim();
    }

    var quantityInput = resolveQuantityInput(form);
    var countElement = root.querySelector("[data-qk-upsell-count]");
    var countLabelElement = root.querySelector("[data-qk-upsell-count-label]");
    var totalContainer = root.querySelector("[data-qk-upsell-total-container]");
    var totalElement = root.querySelector("[data-qk-upsell-total]");
    var selectedElement = root.querySelector("[data-qk-upsell-selected]");
    var liveElement = root.querySelector("[data-qk-upsell-live]");
    var previewDialog = root.querySelector(PREVIEW_DIALOG_SELECTOR);
    var collapseController = createCollapseController(root);
    var carouselController = createCarouselController(root);

    root.addEventListener("click", function (event) {
      var target = event && event.target instanceof Element ? event.target : null;
      var previewTrigger = target ? target.closest(PREVIEW_TRIGGER_SELECTOR) : null;
      var previewClose = target ? target.closest(PREVIEW_CLOSE_SELECTOR) : null;

      if (previewTrigger instanceof HTMLButtonElement && root.contains(previewTrigger)) {
        openPreview(root, previewTrigger);
        return;
      }

      if (previewClose instanceof HTMLButtonElement && root.contains(previewClose)) {
        closePreview(previewDialog);
        return;
      }

      if (previewDialog instanceof HTMLElement && target === previewDialog) {
        closePreview(previewDialog);
        return;
      }

      var trigger = target ? target.closest(CARD_TRIGGER_SELECTOR) : null;

      if (!(trigger instanceof HTMLButtonElement) || !root.contains(trigger)) {
        return;
      }

      var inputId = String(trigger.getAttribute("data-qk-upsell-input-id") || "").trim();
      if (!inputId) {
        return;
      }

      var input = root.querySelector("#" + cssEscape(inputId));
      if (!(input instanceof HTMLInputElement) || input.disabled) {
        return;
      }

      input.checked = !input.checked;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    if (previewDialog instanceof HTMLElement) {
      previewDialog.addEventListener("close", function () {
        var image = previewDialog.querySelector("[data-qk-upsell-preview-image]");
        if (image instanceof HTMLImageElement) {
          image.removeAttribute("src");
          image.alt = "";
        }
      });
    }

    var recalculate = function () {
      var selectedInputs = Array.from(root.querySelectorAll(INPUT_SELECTOR + ":checked:not([disabled])"));
      var parentQuantity = matchParentQuantity ? resolveParentQuantity(quantityInput) : 1;

      var totalCents = selectedInputs.reduce(function (sum, input) {
        var unitPriceCents = Math.max(0, parseInteger(input.getAttribute("data-qk-upsell-price"), 0));
        var effectiveUnitPriceCents = unitPriceCents;
        if (autoDiscountPercent > 0) {
          effectiveUnitPriceCents = Math.max(
            0,
            Math.round((unitPriceCents * (100 - autoDiscountPercent)) / 100),
          );
        }

        return sum + effectiveUnitPriceCents * parentQuantity;
      }, 0);

      root.setAttribute("data-qk-upsell-total-cents", String(totalCents));
      root.dispatchEvent(new CustomEvent("qk:upsell-total:change", {
        bubbles: true,
        detail: {
          formId: formId,
          totalCents: totalCents
        }
      }));

      var selectedTitles = unique(selectedInputs.map(function (input) {
        return input.getAttribute("data-qk-upsell-title");
      }));

      if (countElement instanceof HTMLElement) {
        countElement.textContent = String(selectedInputs.length);
      }

      if (countLabelElement instanceof HTMLElement) {
        var countSingular = String(root.getAttribute("data-qk-upsell-count-singular") || "selectat").trim();
        var countPlural = String(root.getAttribute("data-qk-upsell-count-plural") || "selectate").trim();
        countLabelElement.textContent = selectedInputs.length === 1 ? countSingular : countPlural;
      }

      if (totalContainer instanceof HTMLElement) {
        if (totalContainer.qkUpsellHideTimer) {
          clearTimeout(totalContainer.qkUpsellHideTimer);
          totalContainer.qkUpsellHideTimer = 0;
        }

        var displayedTotalCents = totalElement instanceof HTMLElement
          ? Math.max(
            parseInteger(totalElement.getAttribute("data-qk-upsell-current-cents"), 0),
            parseInteger(totalElement.getAttribute("data-qk-upsell-target-cents"), 0),
          )
          : 0;

        if (selectedInputs.length > 0) {
          totalContainer.hidden = false;
        } else if (displayedTotalCents > 0 && !prefersReducedMotion()) {
          totalContainer.qkUpsellHideTimer = window.setTimeout(function () {
            if (root.querySelectorAll(INPUT_SELECTOR + ":checked:not([disabled])").length === 0) {
              totalContainer.hidden = true;
            }
            totalContainer.qkUpsellHideTimer = 0;
          }, 300);
        } else {
          totalContainer.hidden = true;
        }
      }

      if (totalElement instanceof HTMLElement) {
        animateTotalValue(totalElement, totalCents, moneyFormat, pricePrefix);
      }

      if (selectedElement instanceof HTMLElement) {
        selectedElement.hidden = selectedTitles.length === 0;
        selectedElement.textContent = selectedTitles.length
          ? (selectedTitles.length === 1 ? "Selectat: " : "Selectate: ") + selectedTitles.join(", ")
          : "";
      }

      if (liveElement instanceof HTMLElement) {
        var discountMessage = autoDiscountPercent > 0
          ? " cu " + autoDiscountPercent + "% reducere aplicată."
          : ".";

        liveElement.textContent = selectedInputs.length
          ? selectedInputs.length
            + (selectedInputs.length === 1 ? " produs extra selectat. " : " produse extra selectate. ")
            + "Total extra "
            + pricePrefix
            + formatMoney(totalCents, moneyFormat)
            + discountMessage
          : "Nu ai selectat produse extra.";
      }

      syncCardPressedState(root);
    };

    root.addEventListener("change", function (event) {
      var target = event && event.target instanceof HTMLInputElement ? event.target : null;
      if (!(target instanceof HTMLInputElement) || !target.matches(INPUT_SELECTOR)) {
        return;
      }

      recalculate();
    });

    if (matchParentQuantity && quantityInput instanceof HTMLInputElement) {
      quantityInput.addEventListener("input", recalculate);
      quantityInput.addEventListener("change", recalculate);
    }

    form.addEventListener("variant:change", recalculate);
    collapseController.update();
    carouselController.update();
    recalculate();
  }

  function init(scope) {
    var root = scope instanceof Element || scope instanceof Document ? scope : document;
    var nodes = Array.from(root.querySelectorAll(ROOT_SELECTOR));
    nodes.forEach(initUpsellRoot);

    var priceRoots = Array.from(root.querySelectorAll(MAIN_ATC_PRICE_ROOT_SELECTOR));
    priceRoots.forEach(initMainAtcPriceRoot);
  }

  function bindEvents() {
    document.addEventListener("shopify:section:load", function (event) {
      init(event.target);
    });

    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) {
              return;
            }

            if (node.matches(ROOT_SELECTOR)) {
              initUpsellRoot(node);
            }

            if (node.matches(MAIN_ATC_PRICE_ROOT_SELECTOR)) {
              initMainAtcPriceRoot(node);
            }

            if (node.querySelector(ROOT_SELECTOR) || node.querySelector(MAIN_ATC_PRICE_ROOT_SELECTOR)) {
              init(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
      bindEvents();
    });
  } else {
    init(document);
    bindEvents();
  }
})();
